import { getItems } from "../../../api/repositories/allcourses";

export default {
  async get_courses({ commit }, {perPage, currentPage, query }) {
    try {
      const response = await getItems(perPage, currentPage, query );
      commit("SET_COURSES", response);
    } catch (error) {
      if (error.response.status === 401){
        
        localStorage.clear ();
        window.location.reload();
      }
    }
  },
};
